'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bpfrpt_proptype_RenderFetchingMessage = exports.bpfrpt_proptype_RenderEmptyMessage = exports.bpfrpt_proptype_RenderRow = exports.bpfrpt_proptype_Column = undefined;

var _cell = require('./cell');

var _cell2 = _interopRequireDefault(_cell);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var bpfrpt_proptype_Column = {
  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  name: function name() {
    return (typeof React$Node === 'function' ? _propTypes2.default.instanceOf(React$Node) : _propTypes2.default.any).apply(this, arguments);
  },
  description: function description() {
    return (typeof React$Node === 'function' ? _propTypes2.default.instanceOf(React$Node) : _propTypes2.default.any).apply(this, arguments);
  },
  fieldGetter: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
  width: _propTypes2.default.number,
  minWidth: _propTypes2.default.number,
  maxWidth: _propTypes2.default.number,
  show: _propTypes2.default.bool,
  sticky: _propTypes2.default.bool,
  renderHeadCell: _propTypes2.default.func,
  renderCell: _propTypes2.default.func
};
var bpfrpt_proptype_RenderRow = _propTypes2.default.func;
var bpfrpt_proptype_RenderEmptyMessage = _propTypes2.default.func;
var bpfrpt_proptype_RenderFetchingMessage = _propTypes2.default.func;
exports.bpfrpt_proptype_Column = bpfrpt_proptype_Column;
exports.bpfrpt_proptype_RenderRow = bpfrpt_proptype_RenderRow;
exports.bpfrpt_proptype_RenderEmptyMessage = bpfrpt_proptype_RenderEmptyMessage;
exports.bpfrpt_proptype_RenderFetchingMessage = bpfrpt_proptype_RenderFetchingMessage;